import types from 'pages/Prices/actions/type.js';

const INITIAL_STATE = {
    productPrices: {},
    detailPrices: {},
    modelPrices: {},
};

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.SET_VALUE_PRODUCT_LIST:
            return {
                ...state,
                productPrices: action.payload,
            };
        case types.SET_VALUE_DETAIL_PRICES:
            return {
                ...state,
                detailPrices: action.payload,
            };
        case types.SET_VALUE_MODEL_LIST:
            return {
                ...state,
                modelPrices: action.payload,
            };
        default:
            return state;
    }
}
